import React from 'react';
import styles from '../styles/aboutcomponent.module.css';
import about_founder from '../../../assets/about/about-founder.jpg';
import early_life from '../../../assets/about/20190407_090900-1.jpg';
import ignited_mind from '../../../assets/about/20190111_185822-1.jpg';
import thebeginning from '../../../assets/about/the-beginning.jpg';
import thejourney from '../../../assets/about/20190408_154920-1.jpg';
import sir_teaching from '../../../assets/about/DSC00158-min-480x320.jpg';
import pillar from '../../../assets/about/pillar-4.jpg';

const History = () => {
  return (
    <div className={styles.about_component}>
         {/* ================= HISTORY ================= */}
        <div id="history" className={styles.sectionAnchor}>
          <h2>From Hardship to Hope: The Story of Snehwan</h2>

          <div className={styles.about_container}>
            <div>
              <h4>The Roots of Empathy</h4>
              <p>
                The seed of Snehwan was sown long before its founding, in the
                parched lands of Parbhani, Marathwada. Our founder, Ashok
                Deshmane, did not just witness poverty; he lived it. Growing
                up in a drought-ravaged farming community, he knew the gnawing
                pain of hunger and the uncertainty of tomorrow.
              </p>
              <p>
                To fund his education, a young Ashok worked in garages and
                slept in lorries, surviving on the kindness of truck drivers
                who shared their meals with him. These struggles forged a
                spirit of steel and a heart of gold. Against all odds, he
                earned a Master's in Computer Science and secured a
                prestigious IT job in Pune. He had escaped poverty, but his
                heart remained with those still trapped in it.
              </p>
            </div>
            <div>
              <img src={about_founder} alt="About the founder" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The Awakening</h4>
              <p>
                While working in the comfort of the corporate world, Ashok
                remained haunted by the news of farmer suicides in his
                hometown. Poetry became his outlet, but a visit home in 2015
                changed everything. He saw children abandoned, starving, and
                out of school—victims of their parents' despair.
              </p>
              <p>
                He realized a hard truth: "When there is no food to put in the
                stomach, what's the point of putting anything in the brain?"
                Weekends spent teaching were not enough. The children needed a
                home, safety, and a future.
              </p>
            </div>
            <div>
              <img src={early_life} alt="Early life" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The Great Sacrifice (2015)</h4>
              <p>
                In December 2015, listening to the call of his conscience,
                Ashok founded Snehwan. He began with 18 children from four
                districts. It was a humble beginning fueled by
                sacrifice—Ashok eventually quit his high-paying IT career to
                dedicate his life entirely to the cause.
              </p>
              <p>
                He was not alone; his parents joined him, with his father
                teaching Tabla and his mother cooking for the children,
                turning an institution into a family.
              </p>
            </div>
            <div>
              <img src={ignited_mind} alt="Ignited mind" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The Pillars of Strength</h4>
              <p>
                The movement gained a mother's touch in November 2016, when
                Ashok married Archana. At just 21, she embraced this massive
                responsibility, becoming the mother figure to a growing family
                of over 25 boys and supporting girls from nearby slums.
              </p>
              <p>
                Together, they built a sanctuary where children didn't just
                survive—they thrived through music, dance, yoga, and
                education.
              </p>
            </div>
            <div>
              <img src={thebeginning} alt="The beginning" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>A Permanent Home (2018)</h4>
              <p>
                As the Snehwan family grew, so did the need for space. In a
                life-changing gesture of generosity, Dr. Smita and Dr.
                Ravindra Kulkarni donated two acres of land in Koyali.
              </p>
              <p>
                This allowed Snehwan to move from a rented space in Bhosari to
                its permanent home, establishing the "Late Nalini Kulkarni
                Dnyangram" project.
              </p>
            </div>
            <div>
              <img src={thejourney} alt="The journey" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The Vision Ahead: From Healing to Hope</h4>
              <p>
                Today, Snehwan serves as a sanctuary, healing the scars of
                trauma and poverty for children who have lost their safety
                nets. But we believe that true empowerment lies not just in
                recovery, but in prevention.
              </p>
              <p>
                Many of our children come from agrarian families—families that
                have faced the harshest realities of rural distress. We are
                laser-focused on building an Open School that doesn't force a
                choice between education and heritage, transforming farming
                from a struggle for survival into a source of pride and
                innovation.
              </p>
            </div>
            <div>
              <img src={sir_teaching} alt="Teaching" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Why Snehwan Is Different</h4>
              <p>
                While standard schools focus on creating employees, we focus
                on cultivating changemakers. Our agrarian focus teaches the
                value of hard work, the discipline of patience, and a deep
                respect for the rhythm of nature.
              </p>
              <p>
                The world of 2026 demands more than literacy — we bridge
                tradition and innovation by integrating coding and technology
                with public speaking and leadership, preparing every child not
                just for a job, but for nation building.
              </p>
            </div>
            <div>
              <img src={pillar} alt="Pillars of strength" loading="lazy" />
            </div>
          </div>
        </div>
    </div>
  );
};

export default History;